<!--
 * @Author:
 * @Description: 影响分析、血缘分析图表
-->
<template>
  <div class="w-full h-full">
    <div class="float-right">
      <div
        class="w-16px h-16px rounded-1/2 bg-[#0082ff] inline-block mr-5px relative top-3px"
      ></div>
      <span>分析属性</span>
      <div class="w-20px h-14px bg-[#57d564] inline-block ml-10px mr-5px relative top-3px"></div>
      <span>实体</span>
    </div>
    <v-chart
      ref="effectAnalysis"
      class="w-full h-full"
      :options="effectOptions"
      :autoresize="true"
      :init-options="{ devicePixelRatio: 2 }"
    ></v-chart>
  </div>
</template>

<script>
export default {
  name: 'effectAnalysis',
  props: {
    analysisType: {
      type: String,
      default: '',
    },
    seriesData: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      effectOptions: {
        name: '',
        // 提供数据视图、还原、下载的工具
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            // restore: { show: true },
            // dataView : {show: true, readOnly: false},
            // saveAsImage: { show: true },
          },
        },
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{b}: {c}',
        },
        series: [
          {
            name: '影响分析图',
            type: 'tree',
            orient: 'horizontal', // 竖向或水平   TB代表竖向  LR代表水平
            edgeShape: 'curve', // 控制折线的形式
            // top: '5%',
            initialTreeDepth: 10, // 树图初始展开的层级（深度）
            expandAndCollapse: true, // 点击节点时不收起子节点，default: true
            lineStyle: {
              color: '#D5D5D5',
              width: 1,
            },
            animationDuration: 0, // 防止图片第一次加载不显示
            symbol: 'circle', // 圆点
            symbolSize: 24,
            itemStyle: {
              color: '#0082ff',
              borderColor: '#0082ff',
            },
            label: {
              backgroundColor: '#F4F4F4',
              borderRadius: [0, 0, 5, 5],
              formatter: (params) => {
                console.log(params, '000')
                const showPrimary = params.data.isPrimary ? '{one|主键}' : ''
                const showNullable = params.data.isNullable ? '{two|非空}' : ''
                return [
                  `{first|${params.data.className}}`,
                  `${showPrimary}${showNullable}{second|${params.data.code}}{hr|}{third|${params.data.name}}`,
                ].join('\n')
              },
              rich: {
                first: {
                  backgroundColor: '#57d564',
                  color: '#fff',
                  align: 'center',
                  width: 260,
                  height: 30,
                  borderRadius: 0,
                },
                one: {
                  fontSize: 12,
                  width: 30,
                  height: 24,
                  marginRight: 5,
                  borderRadius: [5, 5, 5, 5],
                  align: 'center',
                  color: '#ff9502',
                  backgroundColor: '#ffe8c9',
                },
                two: {
                  fontSize: 12,
                  width: 30,
                  height: 24,
                  borderRadius: [5, 5, 5, 5],
                  align: 'center',
                  color: '#ff3a30',
                  backgroundColor: '#ffe1e2',
                },
                second: {
                  color: '#888',
                  align: 'center',
                  width: 80,
                  height: 30,
                },
                third: {
                  color: '#888',
                  align: 'center',
                  width: 120,
                  height: 30,
                },
                hr: {
                  borderWidth: 1,
                  height: 30,
                  borderColor: '#D5D5D5',
                },
              },
            },
            leaves: {},
            data: [],
          },
        ],
      },
    }
  },
  watch: {
    seriesData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          const status = {
            label: {
              backgroundColor: 'transparent',
              formatter: (params) => {
                return `${params.data.name}`
              },
              position: 'bottom',
            },
          }
          if (this.analysisType === 'effect') {
            // 影响分析
            this.effectOptions.series[0].data = [{ ...val[0], ...status }]
          } else if (this.analysisType === 'blood') {
            // 血缘分析
            this.effectOptions.series[0].leaves = status
            this.effectOptions.series[0].data = val
          }
        }
      },
    },
  },
  mounted() {},
  methods: {
    // 示例数据(勿删)
    getEffectTreeData() {
      this.effectOptions.series[0].data = [
        {
          name: '电厂编码',
          symbol: 'circle', // 圆点
          symbolSize: 24,
          itemStyle: {
            color: '#0082ff',
            borderColor: '#0082ff',
          },
          label: {
            backgroundColor: 'transparent',
            formatter: (params) => {
              return `${params.name}`
            },
            position: 'bottom',
          },
          children: [
            { name: '电厂1', value: 100 },
            {
              name: '电厂2',
              value: 200,
              children: [
                { name: '电表1', value: 100 },
                { name: '电表1', value: 100 },
              ],
            },
          ],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
